var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "spacing",
    staticStyle: {
      width: "10rem"
    },
    style: {
      height: _vm.formData.mHeight + "px",
      backgroundColor: _vm.formData.bgColor
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };